/**
 * 云服务类别 产品图表页 面包屑
 *
 * @format
 */

import React, { memo, useCallback, useState, useContext, useEffect } from 'react'
import { _$, BreadcrumbItem, Button } from '@king-design/react'
import MonitorCloudCrumb from 'src/pages/MonitorCloud/MonitorCloudCrumb'
// import CloudListTableCopyTips from '../CloudListTable/CloudListTableCopyTips'
import DrawerContainer from 'src/containers/MonitorCloud/CloudListTable/DrawerContainer'
import { DrawerType, DrawerObject } from 'src/pages/MonitorCloud/constants'
import { CountContext } from 'src/pages/MonitorCloud/MonitorCloudChart'
import styled from 'styled-components'

const MonitorBreadCrumb: React.FC<any> = memo(({ className, setRecoverInitView }) => {
  const { curProduct, childTypeValue, instanceId, instanceName, currentInstance, shardValue } =
    useContext(CountContext)
  const [curInstanceId, setCurInstanceId] = useState<string>('')
  const [curInstanceName, setCurInstanceName] = useState<string>('')
  const [drawerObject, setDrawerObject] = useState<DrawerObject>({
    drawerType: undefined,
    visible: false
  })
  const renderRirghtButton = useCallback(() => {
    return (
      <div className="button_box ksc-space">
        <Button
          onClick={() => {
            openDrawer('monitor')
          }}
        >
          {_$('监控项详情')}
        </Button>
        <Button
          onClick={() => {
            openDrawer('alarm')
          }}
        >
          {_$('告警策略详情')}
        </Button>
        <Button onClick={setRecoverInitView}>{_$('恢复默认视图')}</Button>
      </div>
    )
  }, [])

  // 打开详情抽屉
  const openDrawer = (type: DrawerType) => {
    setDrawerObject({
      drawerType: type,
      visible: true
    })
  }

  // 关闭详情抽屉
  const closeDrawer = () => {
    setDrawerObject({
      drawerType: undefined,
      visible: false
    })
  }

  // 判断当前实例ID
  useEffect(() => {
    if (curProduct?.productType !== undefined) {
      if (childTypeValue?.childType) {
        const { childType } = childTypeValue
        if (childType === 53) {
          setCurInstanceId(shardValue.instanceId || '')
          setCurInstanceName(shardValue.instanceName || '')
        } else {
          setCurInstanceId(currentInstance.instanceId || '')
          setCurInstanceName(currentInstance.instanceName || '')
        }
      } else {
        setCurInstanceId(instanceId || '')
        setCurInstanceName(instanceName || '')
      }
    }
  }, [instanceId, currentInstance?.instanceId, shardValue?.instanceId])
  return curProduct?.productType !== undefined ? (
    <div className={className}>
      <MonitorCloudCrumb
        pageType="chart"
        productType={curProduct?.productType}
        curProduct={curProduct}
        rightComponent={renderRirghtButton()}
      >
        <BreadcrumbItem className="crumbItem">
          {instanceName} [{instanceId}]
        </BreadcrumbItem>
      </MonitorCloudCrumb>
      {/* 告警策略 && 监控项抽屉 */}
      <DrawerContainer
        productType={
          childTypeValue?.childType
            ? childTypeValue?.childType + ''
            : String(curProduct?.productType)
        }
        type={drawerObject.drawerType}
        instanceName={curInstanceName}
        instanceId={curInstanceId}
        visible={drawerObject.visible}
        closeDrawer={closeDrawer}
      />
    </div>
  ) : null
})

export default styled(MonitorBreadCrumb)``
